var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.formatted[0])+" "),(_vm.formatted[1])?_c('span',{staticClass:"grey--text"},[_vm._v(" в "+_vm._s(_vm.formatted[1]))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }